import { render, staticRenderFns } from "./OutagesContainer.vue?vue&type=template&id=9896e3f4"
import script from "./OutagesContainer.vue?vue&type=script&lang=js"
export * from "./OutagesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports